import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { RecordUrl } from '../../../../../types';
import { openWindow } from '../../../../../shared/helpers/force-download';

@Component({
  selector: 'app-share-link-modal',
  templateUrl: './share-link-modal.component.html',
  styleUrls: ['./share-link-modal.component.styl']
})
export class ShareLinkModalComponent implements OnInit {
  @Input() recordUrl: RecordUrl;
  copied = false;

  @ViewChild('inputElement') inputElement: ElementRef;

  constructor() {
  }

  ngOnInit() {
  }

  onInputFocus() {
    this.inputElement.nativeElement.select();
  }

  onCopyButtonClick() {
    this.inputElement.nativeElement.select();

    try {
      this.copied = document.execCommand('copy');
    } catch (err) {
    }

    setTimeout(() => this.copied = false, 2000);
  }

  onOpenButtonClick() {
    openWindow(this.recordUrl);
  }
}



// WEBPACK FOOTER //
// ./src/app/rec/components/share/share-link/share-link-modal/share-link-modal.component.ts